import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function CreatorNotFound() {
    const navigate = useNavigate();
    const { username } = useParams();

    return (
        <main className="min-h-screen flex flex-col items-center justify-center p-6"
            style={{ background: 'linear-gradient(160deg, #fce8f3 0%, #fdf4f9 50%, #f8e8f5 100%)' }}>

            {/* 404 */}
            <div className="mb-8 relative">
                <p className="text-[120px] font-bold leading-none tracking-tighter text-[#AF0056]/10 select-none">
                    404
                </p>
                <div className="absolute inset-0 flex items-center justify-center">
                    <p className="text-[120px] font-bold leading-none tracking-tighter text-transparent select-none"
                        style={{ WebkitTextStroke: '2px rgba(175,0,86,0.25)' }}>
                        404
                    </p>
                </div>
            </div>

            <p className="text-sm font-medium text-[#AF0056] tracking-widest uppercase mb-4">
                Creator not found
            </p>

            <h1 className="text-4xl font-bold text-gray-900 mb-5 text-center leading-tight">
                This profile<br />doesn't exist
            </h1>

            <p className="text-sm text-gray-400 text-center mb-10 max-w-xs leading-relaxed">
                The creator you're looking for may have changed their username or deleted their account.
            </p>

            <button
                onClick={() => navigate('/user/creator-list')}
                className="inline-flex items-center justify-center gap-2 them-primary-btn bg-[#AF0056] text-white rounded-full px-8 py-3.5 text-base font-medium shadow-lg transition-all duration-300 hover:opacity-90 hover:scale-105"
            >
                ← Go back home
            </button>

        </main>
    );
}